export const HOME_PATH = '/';
export const API_PATH = '/api';
export const PAGE_PATH = '/pages';
export const POLICY_PATH = '/policies';
export const ACCOUNT_PATH = '/account';
export const AUTHORIZE_ACCOUNT_PATH = `${ACCOUNT_PATH}/authorize`;
export const LOGIN_PATH = `${ACCOUNT_PATH}/login`;
export const LOGOUT_PATH = `${ACCOUNT_PATH}/logout`;
export const SHIPMENTS_PATH = `${ACCOUNT_PATH}/shipments`;
export const ORDERS_PATH = `${ACCOUNT_PATH}/orders`;
export const PERSONAL_PATH = `${ACCOUNT_PATH}/personal`;
export const CART_PATH = '/cart';
export const SEARCH_PATH = '/search';
export const STOREFRONT_PATH = '/storefront';
export const STOREFRONT_REDIRECT_PATH = '/account/locations';
export const PRIVACY_PATH = `${POLICY_PATH}/privacy-policy`;
export const TERMS_PATH = `${POLICY_PATH}/terms-of-service`;
export const SHIPPING_PATH = `${POLICY_PATH}/shipping-policy`;
export const RETURNS_POLICY_PATH = `${POLICY_PATH}/refund-policy`;
export const COLLECTIONS_PATH = '/collections';
export const PRODUCTS_PATH = `${COLLECTIONS_PATH}/all`;
export const REGISTRATION_PATH = `${PAGE_PATH}/registration`;
export const REGISTRATION_STEP_1_PATH = `${REGISTRATION_PATH}/step1`;
export const REGISTRATION_STEP_2_PATH = `${REGISTRATION_PATH}/step2`;
export const REGISTRATION_SUCCESS_PATH = `${REGISTRATION_PATH}/success`;
export const RETURNS_PATH = '/account/returns';
export const RETURNS_NEW_PATH = '/account/returns/new';
export const BLOG_PATH = '/learning-portal';
export const PASSWORD_PROTECTED_PATH = '/password';
export const PASSWORD_PROTECTED_FORM_POST_PATH = '/password.data';
export const HEALTH_PATH = '/health';
export const SANITY_PREVIEW_PATH = '/resource/preview';
export const LOYALTY_PATH = '/account/loyalty';
export const LOYALTY_STATUS_PATH = `${LOYALTY_PATH}/status`;
export const LOYALTY_TRANSACTIONS_PATH = `${LOYALTY_PATH}/transactions`;
export const LOYALTY_FAQS_PATH = `${LOYALTY_PATH}/faqs`;
export const LOYALTY_TERMS_PATH = `${POLICY_PATH}/loyalty-terms-and-conditions`;
export const REMIX_MANIFEST_PATH = '/__manifest';
export const LOYALTY_ABOUT_PATH = `${LOYALTY_PATH}/about`;

/**
 * These routes are protected by login.
 * We need to declare /account sub-routes individually because account/login,
 * account/logout and account/authorized must be non-protected
 */
export const LOGIN_PROTECTED_PATH = [
  BLOG_PATH,
  CART_PATH,
  COLLECTIONS_PATH,
  LOYALTY_PATH,
  ORDERS_PATH,
  PERSONAL_PATH,
  RETURNS_PATH,
  SHIPMENTS_PATH,
];

export const UNREGISTERED_PROTECTED_PATH = [
  REGISTRATION_PATH,
  REGISTRATION_STEP_1_PATH,
  REGISTRATION_STEP_2_PATH,
  REGISTRATION_SUCCESS_PATH,
];
